"use strict";
// views/factures.js
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("../models/globals");
const factureForm_1 = require("./facturation/factureForm");
const boutons_1 = require("../outils/boutons");
const calculs_1 = require("../models/calculs");
const lists_1 = require("../models/lists");
const rechercheProduit_1 = require("./rechercheProduit");
const rechercheClient_1 = require("./rechercheClient");
function ruleTauxRemise(value) {
    if (value == null || value == "" || (value >= 0 && value <= 100))
        return true;
    return false;
}
function rulePrixPositif(value) {
    if (value == null || value == "" || value >= 0)
        return true;
    return false;
}
webix.editors.$popup.text = {
    view: "popup",
    body: {
        view: "textarea",
        width: 420,
        height: 120,
        attributes: { maxLength: 250 }
    }
};
class Factures extends webix_jet_1.JetView {
    constructor() {
        super(...arguments);
        this.changed = false;
        this.locked = false;
        this.editMode = false;
        this.verrouillageEnCours = false;
    }
    config() {
        let toolbar = {
            view: "menu", "borderless": true, "height": 32,
            localId: "menuDocuments",
            elementsConfig: { maxWidth: 250, "borderless": true, },
            // autowidth : true,
            data: [
                boutons_1.creerButton, boutons_1.enregistrerButton, boutons_1.validerButton, boutons_1.annulerButton, boutons_1.supprimerButton,
                {
                    id: "autresButton", view: "button", icon: "mdi mdi-menu", tooltip: (0, globals_1._)("Autres options"),
                    value: "", type: "icon", submenu: [boutons_1.imprimerButton, boutons_1.avoirButton, boutons_1.factureButton, boutons_1.dupliquerButton]
                }
            ],
        };
        let masque = {
            rows: [
                toolbar,
                { body: factureForm_1.factureForm, "borderless": false },
                { template: "", fillspace: true, height: 1 }
            ]
        };
        function verifLigne(ligne) {
            if (Math.abs(ligne.totalLigne) > 0) {
                // @ts-ignore
                if (globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Non") {
                    // en facturation TTC le champ ligne.idTVA n'est pas visible
                    // et la donnée est forcée à 6.
                    return true;
                }
                if (ligne.idTVA > 0) {
                    return true;
                }
                // webix.alert(_("L'indication du code TVA est obligatoire"));
                return false;
            }
            return true;
        }
        let grid = {
            view: "datatable", id: "factureLignesGridId",
            css: "webix_header_border webix_data_border",
            // resizeColumn : true, dragColumn : true,
            columns: factureForm_1.factureLignesGrid,
            rules: {
                remiseLigne: ruleTauxRemise,
                prixVente: rulePrixPositif,
                $obj: verifLigne
            },
            select: true,
            editable: true,
            navigation: true,
            scroll: "y",
            drag: "order",
            dragscroll: true,
            editaction: "custom",
            fixedRowHeight: false,
            on: {
                onValidationError: function (id, obj, details) {
                    let text = [];
                    for (let key in details) {
                        if (key == "remiseLigne")
                            text.push((0, globals_1._)("La remise doit être comprise entre 0 et 100%"));
                        if (key == "prixVente")
                            text.push((0, globals_1._)("Un produit ne peut pas avoir un prix de vente négatif"));
                        if (key == "")
                            text.push((0, globals_1._)("L'indication du code TVA est obligatoire"));
                    }
                    webix.message({ type: "error", text: text.join("<br>") });
                },
                onKeyPress: function (code, e) {
                    let me = this;
                    // lv2.trace(code);
                    let keyCode = code;
                    // déclenchement de la recherche produit uniquement sur Entrée
                    if (code == 13 && !e.ctrlKey && !e.shiftKey && !e.altKey && me.lastEditId.column == "codeArticle") {
                        if (keyCode > 36 && keyCode < 41)
                            return;
                        globals_1.lv2.trace(me.lastEditId.column);
                        const elem = me.getItemNode(me.lastEditId);
                        let code = this.$scope.currentGrid.getItemNode(me.lastEditId).textContent;
                        // @ts-ignore
                        me.getParentView().$scope.rechercheProduit.showPopup(elem, code);
                        return false;
                    }
                    // tab sur dernière ligne dernière colonne ajoute une ligne
                    if (code == 9 && !e.ctrlKey && !e.shiftKey && !e.altKey && me.lastEditId.column == "idTVA") {
                        let id = me.getSelectedId();
                        if (id == me.getLastId()) {
                            this.$scope.ajouterLigne();
                            // obligé de sélectionner la cellule précédente, car le tab reste
                            me.editCell(id.row, "idTVA", false, true);
                            return false;
                        }
                    }
                },
                onItemClick: function (id) {
                    let mName = this.$scope.moduleName + ".update";
                    this.$scope.currentGrid.focus;
                    // let current
                    if (((globals_1.lv2.droits).includes(mName))) {
                        this.editStop();
                        this.editCell(id.row, id.column);
                    }
                },
                onAfterEditStart: function (id) {
                    this.lastEditId = id;
                    let ml = this.getEditor().config.maxlength;
                    if (ml > 0) {
                        this.getEditor().getInputNode().setAttribute("maxlength", ml);
                    }
                },
                onBeforeDrag: function (data, e) {
                    return (e.target).className == "webix_drag_handle";
                },
                onBeforeDrop() {
                    const form = $$("factureFormId");
                    // @ts-ignore
                    if (form.$scope.editMode)
                        return true;
                    return false;
                },
                onAfterDrop: function (data, e) {
                    const form = $$("factureFormId");
                    // @ts-ignore
                    form.$scope.setChanged();
                },
                // "onEditorChange" : function(id,value) { // cet événement n'est pas appelé par Firefox
                // https://forum.webix.com/discussion/36860/oneditorchange-does-not-fire-in-safari-firefox
                onBeforeEditStop: function (state, editor, ignore) {
                    if (editor.column == "designation") {
                        state.value = globals_1.lv2.verifTexte(state.value);
                    }
                    if (editor.column == "prixVente") {
                        state.value = globals_1.lv2.verifMontant(state.value);
                    }
                    if (editor.column == "remiseLigne") {
                        state.value = globals_1.lv2.verifNombre(state.value, 2);
                    }
                    if (editor.column == "quantite") {
                        state.value = globals_1.lv2.verifQuantite(state.value);
                    }
                },
                onAfterEditStop: function (state, editor, ignoreUpdate) {
                    // si la donnée est inchangée on ne fait rien
                    // on est obligé de re-vérifier
                    // toute autre modification, on marque le masque en changed
                    const form = $$("factureFormId");
                    // Si on est parti sur une autre option de menu, on n'a plus accès à la form
                    if (!form)
                        return;
                    if (state.value !== state.old) {
                        // @ts-ignore
                        form.$scope.setChanged();
                    }
                    const dtable = $$("factureLignesGridId");
                    // Si on est parti sur une autre option de menu, on n'a plus accès à la table
                    if (!dtable)
                        return;
                    let item = dtable.getItem(editor.row);
                    // recherche du nouvel article
                    if (editor.column == "codeArticle") {
                        if (state.value !== state.old) {
                            let codeArticle = state.value;
                            // code nature avant modification
                            let oldIdNature = item.idNature;
                            if (state.value.length > 0) {
                                // @ts-ignore
                                let promise = webix.ajax().get(globals_1.phpPath + "articles.php?option=read&codeArticle=" + codeArticle);
                                promise.then(function (result) {
                                    if (result.json().success == false) {
                                        webix.message(result.json().message);
                                        return;
                                    }
                                    let article = result.json();
                                    if (article.articleBloque != 1) {
                                        // dans le cas où on passe d'un non-commentaire à un commentaire
                                        // la ligne de document sera re-créée
                                        if (article.idNature == 3 && oldIdNature != 3) {
                                            item.unid = null;
                                        }
                                        // @ts-ignore
                                        form.$scope.copierArticle(article, item);
                                        dtable.updateItem(editor.row, item);
                                        (0, calculs_1.calculLigne)(item);
                                        (0, calculs_1.calculTotalDocument)(dtable);
                                        if (article.designation == "") {
                                            dtable.editCell(editor.row, "designation");
                                        }
                                        else {
                                            // @ts-ignore
                                            if (globals_1.lv2.ihm.colonneRemiseLignesDocuments == "Oui") {
                                                dtable.editCell(editor.row, "remiseLigne");
                                            }
                                            else {
                                                dtable.editCell(editor.row, "quantite");
                                            }
                                        }
                                    }
                                    else {
                                        webix.alert((0, globals_1._)("Cet article est bloqué à la vente, code ") + codeArticle);
                                        item["codeArticle"] = "";
                                        dtable.editCell(editor.row, "codeArticle");
                                    }
                                });
                            }
                        }
                        // } else {
                        //     // lors de la première édition des lignes, forcer l'édition dans la désignation
                        //     dtable.editCell(editor.row, "designation");
                    }
                    // @ts-ignore
                    if (globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Non") {
                        item["idTVA"] = "6";
                        dtable.updateItem(editor.row, item);
                    }
                    (0, calculs_1.calculLigne)(item);
                    if (item.totalLigne && item.totalLigne != 0) {
                        if (item.idTVA == undefined || item.idTVA < 1) {
                            // @ts-ignore
                            let tva = form.$scope.tvaDefaut;
                            dtable.updateItem(editor.row, {
                                "idTVA": tva
                            });
                        }
                    }
                    // @ts-ignore
                    if (globals_1.lv2.ihm.autoAdjustRowHeight == "Oui") {
                        dtable.adjustRowHeight("designation");
                    }
                    (0, calculs_1.calculTotalDocument)(dtable);
                }
            }
        };
        let gridToolbar = {
            cols: [{
                    template: (0, globals_1._)("Lignes"), css: "webix_header app_header", height: 36, width: 300,
                    "borderless": true
                }, {
                    view: "menu", "borderless": true, "height": 36,
                    id: "docLignesMenu",
                    data: [
                        {
                            view: "button", id: "button-add", icon: "mdi mdi-plus", value: (0, globals_1._)("Ajouter")
                        }, {
                            view: "button", id: "button-delete", icon: "mdi mdi-minus", value: (0, globals_1._)("Supprimer")
                        }
                    ]
                }]
        };
        let liste = { rows: [gridToolbar, grid] };
        // return {
        //     id: "facturesId",
        //     cols:  [masque,  {view: "resizer"}, liste ]
        // };
        return {
            id: "facturesId",
            rows: [toolbar, {
                    cols: [factureForm_1.factureForm, { view: "resizer" }, liste]
                }]
        };
    }
    reload() {
        let idDoc = this.currentForm.getValues()["unid"];
        this.lectureDocument(idDoc);
        this.setUnchanged(); // inutile, car fait dans lectureDocument
    }
    supprimerLigne() {
        this.currentGrid.editStop();
        let vv = this.currentGrid.getSelectedId();
        if (vv) {
            this.currentGrid.remove(vv);
            this.setChanged();
            (0, calculs_1.calculTotalDocument)(this.currentGrid);
            return;
        }
        webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
    }
    enregistrerLignes() {
        // vérifier si un unid est attribué à l'entête, car on en a besoin pour les lignes
        let idDoc = this.currentForm.getValues()["unid"];
        let idTypeDocument = this.currentForm.getValues()["idTypeDocument"];
        if (idDoc < 1) {
            webix.alert("Il FAUT d'abord enregistrer l'entête");
            return;
        }
        // vérification de la conformité des lignes
        if (!this.currentGrid.validate()) {
            webix.alert((0, globals_1._)("Vous avez des erreurs dans les lignes, veuillez corriger pour valider"));
            // return;
        }
        // supprimer toutes les lignes vides à la fin du document
        let gridId = this.currentGrid.getLastId();
        let item = this.currentGrid.getItem(gridId);
        while (item) {
            if ((0, globals_1.isset)(item.codeArticle) || (0, globals_1.isset)(item.designation)
                || (0, globals_1.isset)(item.prixVente) || (0, globals_1.isset)(item.remiseLigne)
                || (0, globals_1.isset)(item.prixNet) || (0, globals_1.isset)(item.quantite)
                || (0, globals_1.isset)(item.totalLigne)) {
                break;
            }
            else {
                let vv = this.currentGrid.getPrevId(gridId);
                this.currentGrid.remove(gridId);
                gridId = vv;
                item = this.currentGrid.getItem(gridId);
            }
        }
        // compléter les informations de chaque ligne
        gridId = this.currentGrid.getFirstId();
        item = this.currentGrid.getItem(gridId);
        let numLigne = 0;
        let me = this;
        while (item) {
            item["idDocument"] = idDoc;
            item.idTypeDocument = idTypeDocument;
            numLigne++;
            item["numLigne"] = numLigne;
            gridId = this.currentGrid.getNextId(gridId);
            item = this.currentGrid.getItem(gridId);
        }
        // Enregistrement global
        // Array des données de la table
        let payload = this.currentGrid.serialize();
        // de array vers JSON
        // suite au passage en V10 suppression de la ligne suivante
        // let vv = JSON.stringify({...payload})
        // Enregistrement
        // @ts-ignore
        let promise = webix.ajax().headers({ "Content-type": "application/json" })
            .post(globals_1.phpPath + "documentsLignes.php?option=savejson&idDocument=" + idDoc, { payload });
        promise.then(function (result) {
            // retour du nombre de lignes créées, même s'il y a eu erreur
            let creations = result.json().creations;
            if (creations > 0) {
                // retour de la liste des créations : numligne/unid
                let listeCreations = result.json().listeCreations;
                let lp = Object.keys(listeCreations);
                lp.forEach((key) => {
                    numLigne = parseInt(key);
                    let idLigne = me.currentGrid.getIdByIndex(numLigne);
                    let item = me.currentGrid.getItem(idLigne);
                    item.unid = listeCreations[key];
                });
            }
            if (result.json().success == false) {
                let factureValideField = me.$$("factureValide");
                factureValideField.setValue(result.json().message);
                webix.alert(result.json().message);
                return;
            }
            webix.message("Données enregistrées");
        });
        promise.catch(function () {
            webix.alert((0, globals_1._)("Erreur d'enregistrement des lignes de document"));
        });
        return;
        // fin enregistrement global
    }
    ajouterLigne() {
        let data = { "unid": "", "codeArticle": "", "designation": "" };
        this.currentGrid.editStop();
        this.currentGrid.add(data, this.currentGrid.count());
        let $id = this.currentGrid.getLastId();
        this.currentGrid.select($id, false);
    }
    setEditMode(bool) {
        this.editMode = bool;
        let menu = this.$$("menuDocuments");
        let lignesMenu = $$("docLignesMenu");
        // usage non classique ici : editmode = false si le document est validé (non modifiable)
        if (bool) {
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("creerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("enregistrerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".validate,"))
                menu.showMenuItem("validerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("annulerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,"))
                menu.showMenuItem("supprimerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("dupliquerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("imprimerButton");
            this.currentGrid.config.editable = true; // enable();
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                lignesMenu.showMenuItem("button-add");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                lignesMenu.showMenuItem("button-delete");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                $$("rechercherClientDocument").show();
            Object.values(this.currentForm.elements).forEach(val => {
                // @ts-ignore
                val.enable();
            });
        }
        else {
            menu.hideMenuItem("creerButton");
            if ((globals_1.lv2.droits).includes(this.moduleName + ".save,"))
                menu.showMenuItem("creerButton");
            menu.hideMenuItem("enregistrerButton");
            menu.hideMenuItem("validerButton");
            menu.hideMenuItem("annulerButton");
            menu.hideMenuItem("supprimerButton");
            this.currentGrid.config.editable = false; //disable();
            lignesMenu.hideMenuItem("button-add");
            lignesMenu.hideMenuItem("button-delete");
            $$("rechercherClientDocument").hide();
            Object.values(this.currentForm.elements).forEach(val => {
                // @ts-ignore
                val.disable();
            });
        }
    }
    forcerVerrou(idDoc, result) {
        let me = this;
        webix.confirm({
            title: (0, globals_1._)("Demande de verrou"),
            text: result.json().message,
            cancel: (0, globals_1._)("Forcer le verrou"),
            ok: (0, globals_1._)("Annuler")
        }).then(function () {
            // lorsque la demande de verrou est provoquée par une modification de ligne,
            // après le reload, quand on quitte le champ modifié on a "Invalid ID for updateItem"
            me.verrouillageEnCours = true; // pour éviter une 2° demande de verrou
            me.currentGrid.editCancel();
            me.verrouillageEnCours = false;
            me.reload();
        }).catch(function () {
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "factures.php?option=lock&unid=" + idDoc + "&force=1");
            promise.then(function (result) {
                if (result.json().success == false) {
                    me.forcerVerrou(idDoc, result);
                    return;
                }
                else {
                    globals_1.lv2.trace("Verrou forcé");
                    me.locked = true;
                    return;
                }
            });
            promise.catch(() => {
                webix.alert((0, globals_1._)("Erreur sur demande de forcer verrou"));
                return;
            });
        });
    }
    // tentative de pose de verrou sur le document
    verrou() {
        globals_1.lv2.trace("Demande de verrou sur un document avec id (déjà enregistré)");
        if (this.verrouillageEnCours)
            return;
        this.verrouillageEnCours = true;
        let me = this;
        let idDoc = this.idDocumentField.getValue();
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "factures.php?option=lock&unid=" + idDoc);
        promise.then(function (result) {
            if (result.json().success == false) {
                // me.setEditMode(false);
                me.verrouillageEnCours = false;
                me.forcerVerrou(idDoc, result);
                return;
            }
            else {
                globals_1.lv2.trace("Verrou posé");
                me.locked = true;
                me.verrouillageEnCours = false;
                return true;
            }
        });
        promise.catch(() => {
            me.verrouillageEnCours = false;
            webix.alert((0, globals_1._)("Erreur sur demande de verrou"));
            return;
        });
    }
    deverrou() {
        let me = this;
        if (me.locked == false) {
            return;
        }
        // déverrouillage du document si un id lui est affecté
        let idDoc = me.idDocumentField.getValue();
        if (idDoc > 0) {
            globals_1.lv2.trace("Requête de déverrou");
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "factures.php?option=unlock&unid=" + idDoc);
            promise.then(function (result) {
                if (result.json().success == false) {
                    me.setEditMode(false);
                    webix.alert(result.json().message);
                    return;
                }
                me.locked = false;
                $$("deconnexionButton").enable();
                return;
            });
            promise.catch(function () {
                me.setEditMode(false);
                webix.alert((0, globals_1._)("Erreur de déverrouillage du document"));
                return;
            });
        }
    }
    enregistrerDocument(validation) {
        let me = this;
        // Le re-calcul est obligatoire si on modifie une ligne
        // et que l'on appelle l'enregistrement sans quitter le champ modifié.
        // Finalement, avec la temporisation de l'appel de l'enregistremen cela n'est plus nécessaire
        // calculTotalDocument(me.currentGrid);
        let numDoc = me.$$("numeroDocument");
        let values = me.currentForm.getValues();
        globals_1.lv2.trace(values.totalHT);
        let req = "factures.php?option=save";
        if (validation)
            req = "factures.php?option=validate";
        // @ts-ignore
        let promise = webix.ajax().post(globals_1.phpPath + req, values);
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            globals_1.lv2.trace("Entête enregistrée");
            if (Number(me.idDocumentField.getValue()) < 1) {
                me.verrouillageEnCours = true; // pour éviter une demande de verrou ici
                me.idDocumentField.setValue(result.json().unid);
                // laisser le temps à onChange de traiter la demande
                setTimeout(function () {
                    me.verrouillageEnCours = false;
                }, 20);
            }
            if (validation) {
                if (numDoc.getValue().length < 2) {
                    numDoc.setValue(result.json().numeroDocument);
                    me.setEditMode(false);
                    // me.deverrou();
                    me.setUnchanged();
                    return;
                }
            }
            me.setUnchanged();
            // enregistrer les lignes
            me.enregistrerLignes();
        });
        promise.catch(function () {
            webix.alert((0, globals_1._)("Erreur d'enregistrement de l'entête"));
        });
    }
    enregistrer() {
        // vérification du masque
        if (!this.currentForm.validate()) {
            webix.alert((0, globals_1._)("Veuillez corriger les données avant d'enregistrer"))
                .then(function () {
                return false;
            });
            return false;
        }
        let me = this;
        // @ts-ignore
        let totalHT = me.$$("totalHT").getValue();
        if (totalHT == 0) {
            let promise = webix.confirm((0, globals_1._)("Veuillez confirmer l'enregistrement de ce document dont le total HT est nul"));
            promise.then(function () {
                me.enregistrerDocument(false);
            }).catch(function () {
                return false;
            });
        }
        else {
            // un temps d'attente après le clic sur le bouton pour donner la priorité au calcul du document
            setTimeout(function () {
                me.enregistrerDocument(false);
            }, 50);
        }
    }
    valider() {
        // validation du document
        // si un élément est invalide, la validation devient un enregistrement simple
        let me = this;
        let values = this.currentForm.getValues();
        let validation = true;
        if (values.factureValide !== "" && values.factureValide !== "Ok") {
            webix.alert((0, globals_1._)(values.factureValide));
            validation = false;
        }
        if (!this.currentForm.validate()) {
            webix.alert((0, globals_1._)("La date est obligatoire"));
            validation = false;
        }
        // vérification de la conformité des lignes
        if (!this.currentGrid.validate()) {
            webix.alert((0, globals_1._)("Vous avez des erreurs dans les lignes, veuillez corriger pour valider"));
            validation = false;
        }
        webix.confirm("Veuillez confirmer la validation du document. Plus aucune modification ne sera possible.").then(() => { this.enregistrerDocument(validation); });
    }
    creer() {
        let me = this;
        // me.deverrou();
        me.setEditMode(true);
        let data = { "unid": "", "idTypeDocument": me.defaultIdTypeDocument, dateDocument: new Date() };
        me.currentForm.setValues(data);
        me.currentGrid.clearAll();
        for (let i = 0; i < 8; i++) {
            me.ajouterLigne();
        }
        if (me.compteClientsComptant == undefined) {
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=clients.comptant&option=read");
            promise.then(function (result) {
                me.compteClientsComptant = result.json().texte;
                me.compteComptaField.setValue(me.compteClientsComptant);
                me.setUnchanged();
                me.codeClientField.focus();
            });
        }
        else {
            me.compteComptaField.setValue(me.compteClientsComptant);
            me.setUnchanged();
            me.codeClientField.focus();
        }
        // pour une création , le bouton valider n'a pas à être activé
        let menu = this.$$("menuDocuments");
        menu.disableItem("validerButton");
    }
    imprimer() {
        let me = this;
        let idDoc = me.currentForm.getValues()["unid"];
        // @ts-ignore
        webix.ajax().response("blob").get(globals_1.phpPath + "/printing/document.php?unid=" + idDoc, function (text, data) {
            //data - is a data blob
            // @ts-ignore
            webix.html.download(data, "document.pdf");
        });
    }
    dupliquer() {
        let form = this.currentForm;
        let facture = form.getValues();
        // this.deverrou();
        (0, calculs_1.copierFacture)(facture, form, this.defaultIdTypeDocument);
        this.setEditMode(true);
    }
    annuler() {
        let me = this;
        // @ts-ignore
        if (this.$$("idDocument").getValue() > 0) {
            webix.confirm({
                title: (0, globals_1._)("Confirmation"),
                text: (0, globals_1._)("Veuillez confirmer le retour au document enregistré"),
                cancel: (0, globals_1._)("Annuler"),
                ok: (0, globals_1._)("OK")
            }).then(function () {
                // me.deverrou();
                me.reload();
                return;
            });
        }
        else {
            webix.confirm({
                title: (0, globals_1._)("Confirmation"),
                text: (0, globals_1._)("Veuillez confirmer l'annulation de la saisie du document'"),
                cancel: (0, globals_1._)("Annuler"),
                ok: (0, globals_1._)("OK")
            }).then(function () {
                me.creer();
                return;
            });
        }
    }
    supprimer() {
        let me = this;
        webix.confirm({
            title: (0, globals_1._)("Confirmation"),
            text: (0, globals_1._)("Veuillez confirmer la suppression de ce document"),
            cancel: (0, globals_1._)("Annuler"),
            ok: (0, globals_1._)("OK")
        }).then(function () {
            let idDoc = me.currentForm.getValues()["unid"];
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "factures.php?option=delete&unid=" + idDoc);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                webix.message((0, globals_1._)("Document supprimé"));
                me.creer();
            });
            promise.catch(function () {
                webix.alert((0, globals_1._)("Erreur de suppression du document"));
            });
        });
    }
    annulerClient() {
        for (let i = 0; i < this.champsCommuns.length; i++) {
            // @ts-ignore
            this.$$(this.champsCommuns[i]).setValue("");
        }
        this.compteComptaField.setValue(this.compteClientsComptant);
    }
    copierClient(data) {
        this.setChanged();
        for (let i = 0; i < this.champsCommuns.length; i++) {
            // @ts-ignore
            this.$$(this.champsCommuns[i]).setValue(data[this.champsCommuns[i]]);
        }
    }
    lireCopierClient(codeClient) {
        let me = this;
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "clients.php?option=read&codeClient=" + codeClient);
        promise.then(function (result) {
            if (result.json().success == false) {
                let promise = webix.alert(result.json().message);
                promise.then(function () {
                    me.codeClientField.focus();
                });
                me.codeClientField.setValue("");
                me.annulerClient();
                return;
            }
            // annuler l'unid du client
            let defaultData = result.json();
            defaultData.idClient = defaultData.unid;
            defaultData.unid = 0;
            me.copierClient(defaultData);
            return;
        });
    }
    confirmExit() {
        return webix.confirm({
            title: (0, globals_1._)("Les données ne sont pas enregistrées."),
            text: (0, globals_1._)("Voulez-vous quitter quand même ?"),
            ok: (0, globals_1._)("Oui"),
            cancel: (0, globals_1._)("Non")
        });
    }
    exit() {
        let me = this;
        return new Promise(function (resolve, reject) {
            me.confirmExit().then(function () {
                me.setUnchanged();
                resolve(0);
            }).catch(function (onRejected) {
                let menuGauche = $$("menu");
                menuGauche.blockEvent();
                menuGauche.select("factures", false);
                menuGauche.unblockEvent();
                onRejected();
                //reject();
            });
        });
    }
    avoir() {
        let form = this.currentForm;
        let facture = form.getValues();
        if (facture.idTypeDocument != 1) {
            webix.alert((0, globals_1._)("Ce document n'est pas une facture"));
            return;
        }
        if (facture.totalHT < 0) {
            webix.alert((0, globals_1._)("Le total H.T. de cette facture est négatif, impossible de créer un avoir."));
            return;
        }
        if (facture.totalHT > 0) {
            webix.confirm({
                title: (0, globals_1._)("Confirmation"),
                text: (0, globals_1._)("Un avoir sur facture sera créé à partir de cette facture.") +
                    (0, globals_1._)("Toutes les quantités positives deviendront négatives et réciproquement."),
                cancel: (0, globals_1._)("Annuler"),
                ok: (0, globals_1._)("OK")
            }).then(() => {
                (0, calculs_1.copierFacture)(facture, form, 14);
                this.setEditMode(true);
            });
        }
        else {
            (0, calculs_1.copierFacture)(facture, form, 14);
            this.setEditMode(true);
        }
    }
    // Création de facture à partir de devis ou de proforma
    facture() {
        let form = this.currentForm;
        let facture = form.getValues();
        if (facture.idTypeDocument != 2 && facture.idTypeDocument != 3) {
            webix.alert((0, globals_1._)("Ce document n'est pas un devis ou une pro-forma"));
            return;
        }
        if (facture.totalHT <= 0) {
            webix.alert((0, globals_1._)("Le total H.T. de ce devis est négatif ou nul, impossible de créer une facture."));
            return;
        }
        webix.confirm({
            title: (0, globals_1._)("Confirmation"),
            text: (0, globals_1._)("Une facture sera créé à partir de ce document."),
            cancel: (0, globals_1._)("Annuler"),
            ok: (0, globals_1._)("OK")
        }).then(() => {
            (0, calculs_1.copierFacture)(facture, form, 1);
            // sélection de la bonne option dans le menu de gauche
            let menuGauche = $$("menu");
            menuGauche.unselectAll();
            // @ts-ignore
            menuGauche.open("facturation");
            menuGauche.blockEvent();
            menuGauche.select("factures", false);
            menuGauche.unblockEvent();
            this.setEditMode(true);
        });
    }
    copierArticle(produit, item) {
        item.idNature = produit.idNature;
        item.designation = produit.designation;
        item.prixVente = produit.prixVente;
        item.idTVA = produit.idTVA;
        // @ts-ignore
        if (!globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Oui") {
            item.idTVA = "6";
        }
        item.prixAchat = produit.prixAchat;
        item.idNature = produit.idNature;
        item.remiseLigne = 0; // TODO : ne faut-il pas mettre "" au lieu de 0
    }
    init() {
        // Les données suivantes sont surchargées si la classe est dérivée
        this.moduleName = "facturation";
        this.defaultIdTypeDocument = 1;
        let me = this;
        this.currentForm = $$("factureFormId");
        this.currentGrid = $$("factureLignesGridId");
        this.champsCommuns = ["idClient", "codeClient", "adresseNom", "adresseSuite", "adresseRue", "adresseCP", "adresseVille", "pays",
            "modeReglement", "numTVA", "comptePro", "compteCompta", "noteFacture"];
        this.codeClientField = this.$$("codeClient");
        // Affichage du décompte de TVA
        // @ts-ignore
        if (globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Oui") {
        }
        else {
            // @ts-ignore
            this.$$("tvaCell").hide();
            // @ts-ignore
            this.$$("ttcCell").show();
            this.currentGrid.hideColumn("idTVA");
        }
        // @ts-ignore
        if (globals_1.lv2.ihm.colonneRemiseLignesDocuments == "Oui") {
        }
        else {
            this.currentGrid.hideColumn("remiseLigne");
            this.currentGrid.hideColumn("prixNet");
        }
        this.setEditMode(false);
        // Maintenant j'applique les personalisations.
        // Je charge les personnalisations
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=factures.TVAdefaut&option=read");
        promise.then(function (result) {
            me.tvaDefaut = parseInt(result.json().valeur);
        });
        // liens menu-> fonction
        let menu = this.$$("menuDocuments");
        // @ts-ignore
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "creerButton":
                    me.creer();
                    break;
                case "enregistrerButton":
                    me.enregistrer();
                    break;
                case "validerButton":
                    me.valider();
                    break;
                case "annulerButton":
                    me.annuler();
                    break;
                case "supprimerButton":
                    me.supprimer();
                    break;
                case "dupliquerButton":
                    me.dupliquer();
                    break;
                case "imprimerButton":
                    me.imprimer();
                    break;
                case "avoirButton":
                    me.avoir();
                    break;
                case "factureButton":
                    me.facture();
                    break;
            }
        });
        // Activation de la recherche client
        if (!this.rechercheClient) {
            // @ts-ignore
            this.rechercheClient = this.ui(rechercheClient_1.default);
        }
        let boutonRechercherClient = $$("rechercherClientDocument");
        boutonRechercherClient.attachEvent("onItemClick", function () {
            const elem = boutonRechercherClient.getNode();
            // @ts-ignore
            me.rechercheClient.showPopup(elem, me.codeClientField.getValue());
        });
        this.app.attachEvent("code:client:choisi", function (item) {
            globals_1.lv2.trace(item.codeClient);
            // me.codeClientField.setValue(item.codeClient);
            me.lireCopierClient(item.codeClient);
        });
        // Création de la recherche produit
        if (!this.rechercheProduit) {
            // @ts-ignore
            this.rechercheProduit = this.ui(rechercheProduit_1.default);
        }
        this.app.attachEvent("code:produit:choisi", function (item) {
            globals_1.lv2.trace(item.codeArticle);
            // Obligé d'ajouter le timeout, sinon let id=.. provoque une erreur
            // Ceci est apparu avec la V10.0.1, me.currentgrid n'est pas défini tant que la fenêtre de recherche n'est pas refermée
            setTimeout(function () {
                let id = me.currentGrid.getSelectedId();
                let ligne = me.currentGrid.getItem(id);
                me.currentGrid.updateItem(id, { codeArticle: item.codeArticle });
                // @ts-ignore
                let promise = webix.ajax().get(globals_1.phpPath + "articles.php?option=read&codeArticle=" + item.codeArticle);
                promise.then(function (result) {
                    if (result.json().success == false) {
                        webix.message(result.json().message);
                        return;
                    }
                    let article = result.json();
                    // @ts-ignore
                    me.copierArticle(article, ligne);
                    me.currentGrid.updateItem(id, ligne);
                    (0, calculs_1.calculLigne)(ligne);
                    (0, calculs_1.calculTotalDocument)(me.currentGrid);
                    if (article.designation == "") {
                        me.currentGrid.editCell(id, "designation");
                    }
                    else {
                        // @ts-ignore
                        if (globals_1.lv2.ihm.colonneRemiseLignesDocuments == "Oui") {
                            me.currentGrid.editCell(id, "remiseLigne");
                        }
                        else {
                            me.currentGrid.editCell(id, "quantite");
                        }
                    }
                });
            }, 20);
        });
        let lignesMenu = $$("docLignesMenu");
        lignesMenu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouterLigne();
                    break;
                case "button-delete":
                    me.supprimerLigne();
                    break;
            }
        });
        this.lastSelectedId = 0;
        this.lastAction = "";
        this.use(webix_jet_1.plugins.UnloadGuard, function () {
            // if (me.locked) {
            // 	// me.deverrou();
            // 	$$("deconnexionButton").enable();
            // }
            if (me.changed) {
                return me.exit();
            }
        });
        if (globals_1.lv2.userPrefs) {
            if ("factureformwidth" in globals_1.lv2.userPrefs) {
                this.currentGrid.define("width", globals_1.lv2.userPrefs["factureformwidth"]);
                this.currentGrid.resize();
            }
        }
        let clientPro = this.$$("comptePro");
        // @ts-ignore
        clientPro.attachEvent("onChange", function (newValue) {
            if (newValue == 1) {
                // @ts-ignore
                me.$$("numTVA").show();
                // @ts-ignore
                me.$$("adresseNom").show();
            }
            else {
                // @ts-ignore
                me.$$("numTVA").hide();
                // neutralisation de l'affichage nom prenom
                // @ts-ignore
                me.$$("adresseNom").show();
            }
        });
        this.codeClientField.attachEvent("onFocus", function (current_view, prev_view) {
            me.prevCodeClient = current_view.getValue();
        });
        this.codeClientField.attachEvent("onBlur", function (prev_view) {
            let vv = prev_view.getValue();
            if (vv == me.prevCodeClient)
                return;
            if (vv == "") {
                me.prevCodeClient = ""; // HACK : si je ne le fais pas, le onFocus ne réagit plus !!!
                me.annulerClient();
                return;
            }
            me.lireCopierClient(vv);
        });
        // Affichage du type de document
        let idTypeDocumentField = this.$$("idTypeDocument");
        let typeDocumentLabel = this.$$("typeDocument");
        // @ts-ignore
        idTypeDocumentField.attachEvent("onChange", function (newValue) {
            let typeDocument = lists_1.typeDocumentList.find(o => o.id == newValue);
            // @ts-ignore
            typeDocumentLabel.setValue(typeDocument.value);
        });
        // gestion de la modification du document par la modification de l'entête
        let form = this.currentForm;
        for (let i in form.elements) {
            form.elements[i].attachEvent("onChange", function (newV, oldV, config) {
                if (config) {
                    me.setChanged();
                }
            });
        }
        // pour le dernier champ du masque, si touche 'Tab' alors focus sur 1° ligne de document
        let fflf = this.$$("factureFormLastField");
        fflf.attachEvent("onKeyPress", function (code, e) {
            if (code == 9 && !e.ctrlKey && !e.shiftKey && !e.altKey) {
                // webix.UIManager.setFocus(me.currentGrid); //to set focus
                let id = me.currentGrid.getFirstId();
                me.currentGrid.select(id); //to mark focusing visually
                me.currentGrid.editCell(id, "codeArticle", true, true);
                return false;
            }
        });
    }
    // Si le document est modifié et non enregistré : désactivation des boutons
    setChanged() {
        // this.currentForm.setDirty(true);
        if (!this.changed) {
            this.changed = true;
            let menu = this.$$("menuDocuments");
            menu.disableItem("creerButton");
            menu.disableItem("validerButton");
            menu.disableItem("dupliquerButton");
            menu.disableItem("autresButton");
            $$("deconnexionButton").disable();
        }
        if (!this.locked) {
            let idDoc = this.idDocumentField.getValue();
            if (idDoc > 0) {
                this.verrou();
            }
        }
    }
    // Si le document est enregistré : réactivation des boutons
    setUnchanged() {
        // this.currentForm.setDirty(false);
        if (this.changed) {
            this.changed = false;
            let menu = this.$$("menuDocuments");
            menu.enableItem("creerButton");
            menu.enableItem("validerButton");
            menu.enableItem("dupliquerButton");
            menu.enableItem("autresButton");
            $$("deconnexionButton").enable();
        }
        if (this.locked) {
            this.deverrou();
        }
    }
    lectureDocument(idDoc) {
        globals_1.lv2.trace("Lecture du document existant");
        let me = this;
        me.setEditMode(false);
        // @ts-ignore
        let promiseDocument = webix.ajax().get(globals_1.phpPath + "factures.php?option=read&unid=" + idDoc);
        promiseDocument.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            let data = result.json();
            // introduit pour facturation TTC
            data.totalTTC2 = data.totalTTC;
            me.currentForm.setValues(data);
            if (data.numeroDocument > 0 || data.numeroDocument.length > 2 || me.lecteur) {
                globals_1.lv2.trace("on reste en consultation");
            }
            else {
                me.setEditMode(true);
                // me.verrou();
            }
        });
        // @ts-ignore
        let promiseLignes = webix.ajax().get(globals_1.phpPath + "documentsLignes.php?option=list&idDocument=" + idDoc);
        promiseLignes.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            let data = result.json();
            let dtable = me.currentGrid;
            dtable.clearAll();
            dtable.parse(data);
            // @ts-ignore
            if (globals_1.lv2.ihm.autoAdjustRowHeight == "Oui") {
                dtable.adjustRowHeight("designation");
            }
            //  vilain HACK supprimé grâce à echo(json_encode($row,JSON_NUMERIC_CHECK));
            me.setUnchanged();
        });
        return;
    }
    ready() {
        this.compteComptaField = $$("compteCompta");
        this.idDocumentField = $$("idDocument");
        let me = this;
        // si l'utilisateur n'est que lecteur
        this.lecteur = true;
        if (globals_1.lv2.droits.includes("facturation.save")
            || globals_1.lv2.droits.includes("facturation.update")
            || globals_1.lv2.droits.includes("facturation.delete")
            || globals_1.lv2.droits.includes("facturation.validate")) {
            this.lecteur = false;
        }
        let menu = this.$$("menuDocuments");
        if (this.lecteur) {
            menu.hideMenuItem("avoirButton");
            menu.hideMenuItem("dupliquerButton");
            menu.hideMenuItem("factureButton");
        }
        // supprimer les options superflues du menu
        if (this.defaultIdTypeDocument == 1) {
            menu.hideMenuItem("factureButton");
        }
        let params = this.getUrl()[0].params;
        let idClient = 0;
        if (params.client) {
            // création d'une facture pour ce client
            idClient = Number(params.client);
            // lecture de la fiche client
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "clients.php?option=read&unid=" + idClient);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                // annuler le unid du client
                let defaultData = result.json();
                defaultData.idClient = defaultData.unid;
                defaultData.unid = 0;
                defaultData.dateDocument = new Date();
                defaultData.idTypeDocument = me.defaultIdTypeDocument;
                me.currentForm.setValues(defaultData);
            });
            // on ouvre d'office 8 liges
            for (let i = 0; i < 8; i++) {
                this.ajouterLigne();
            }
            this.currentGrid.editStop();
            this.currentGrid.select(this.currentGrid.getFirstId());
            if (!me.lecteur)
                this.setEditMode(true);
            return;
        }
        // ouverture avec chargement de facture
        if (params.unid) {
            me.lectureDocument(params.unid);
            return;
        }
        // Tous les autres cas : création d'une facture
        this.creer();
    }
}
exports.default = Factures;
